(() => {
  if (!location.pathname.replace(/\/$/, '').endsWith('/policies/refund-policy')) return;

  const main = document.querySelector('#MainContent.gds-b-pages');
  const template = main?.querySelector('#RefundPolicyCanonicalTemplate');
  const container = main?.querySelector('.shopify-policy__container');
  const body = container?.querySelector('.shopify-policy__body');
  const content = body?.querySelector('.rte') || body;

  if (!main || !template || !container || !content || main.querySelector('.refund-policy-canonical')) return;

  document.body.classList.add('refund-policy-canonical-active');
  container.before(template.content.cloneNode(true));

  const shell = main.querySelector('.refund-policy-canonical');
  const nav = shell?.querySelector('[data-refund-nav]');
  const host = shell?.querySelector('[data-refund-content]');
  if (!shell || !nav || !host) return;

  const slugify = (value) => value.toLowerCase().trim().replace(/&/g, 'and').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

  const nodes = [...content.childNodes];
  let currentSection = null;
  let currentBody = null;
  let currentSubcard = null;
  let intro = null;
  const headings = [];

  nodes.forEach((node) => {
    if (node.nodeType === 1 && node.tagName === 'H2') {
      const title = node.textContent.trim();
      const id = 'refund-' + slugify(title);

      currentSection = document.createElement('section');
      currentSection.className = 'refund-canonical__section refund-canonical__section--' + slugify(title);
      currentSection.id = id;

      node.setAttribute('tabindex', '-1');

      currentBody = document.createElement('div');
      currentBody.className = 'refund-canonical__section-body';
      currentSection.append(node, currentBody);
      host.append(currentSection);
      currentSubcard = null;
      headings.push({ title, id, node });

      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = '#' + id;
      link.textContent = title;
      item.append(link);
      nav.append(item);
      return;
    }

    if (node.nodeType === 1 && node.tagName === 'H3' && currentBody) {
      const title = node.textContent.trim();
      currentSubcard = document.createElement('div');
      currentSubcard.className = 'refund-canonical__subcard';

      currentSubcard.append(node);
      currentBody.append(currentSubcard);
      return;
    }

    if (node.nodeType === 1 && node.tagName === 'HR') {
      node.remove();
      return;
    }

    if (currentSubcard) {
      currentSubcard.append(node);
      return;
    }

    if (currentBody) {
      currentBody.append(node);
      return;
    }

    if (node.textContent?.trim()) {
      if (!intro) {
        intro = document.createElement('div');
        intro.className = 'refund-canonical__intro';
        host.prepend(intro);
      }
      intro.append(node);
    }
  });

  container.hidden = true;

  const links = [...nav.querySelectorAll('a')];
  const activate = (index) => {
    links.forEach((link, linkIndex) => {
      if (linkIndex === index) link.setAttribute('aria-current', 'location');
      else link.removeAttribute('aria-current');
    });
  };
  if (links.length) activate(0);

  links.forEach((link, index) => {
    link.addEventListener('click', (event) => {
      const target = shell.querySelector(link.getAttribute('href'));
      if (!target) return;
      event.preventDefault();
      const header = document.querySelector('.section-header');
      const announcement = document.querySelector('.section-announcement-bar, .announcement-bar-section');
      const offset = Math.max(0, header?.getBoundingClientRect().bottom || 0, announcement?.getBoundingClientRect().bottom || 0) + 24;
      const top = target.getBoundingClientRect().top + window.scrollY - offset - 20;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      target.querySelector('h2')?.focus({ preventScroll: true });
      history.replaceState(null, '', link.hash);
      activate(index);
    });
  });

  let queued = false;
  const update = () => {
    queued = false;
    const header = document.querySelector('.section-header');
    const announcement = document.querySelector('.section-announcement-bar, .announcement-bar-section');
    const offset = Math.max(0, header?.getBoundingClientRect().bottom || 0, announcement?.getBoundingClientRect().bottom || 0) + 24;
    shell.style.setProperty('--refund-sticky-offset', offset + 'px');

    let active = 0;
    headings.forEach((heading, index) => {
      if (heading.node.getBoundingClientRect().top <= offset + 90) active = index;
    });
    activate(active);
  };

  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(update);
  };

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  update();
})();